<template>
  <b-modal id="modal-reset-password-smd-user" size="md" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="KeyIcon" class="mr-05" />
        <span class="fs-18">Reset Password User Sosmed</span>
      </div>
    </template>
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0" v-if="data">
      <b-card-body>
        <b-alert show variant="warning" class="mb-1">
          <feather-icon icon="AlertTriangleIcon" class="mr-05" />
          Reset password untuk <strong>{{ data.username }}</strong> ({{ data.platform === 'facebook' ? 'Facebook' : 'Instagram' }})
        </b-alert>
        <validation-observer ref="formRules">
          <b-form>
            <!-- Password Baru -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Password Baru" rules="required">
                <label for="new-password">Password Baru <span class="text-danger">*</span></label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="KeyIcon" />
                  </b-input-group-prepend>
                  <b-form-input v-model="new_password" id="new-password" placeholder="Masukkan Password Baru" type="password" />
                </b-input-group>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- Konfirmasi Password -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Konfirmasi Password" rules="required">
                <label for="confirm-password">Konfirmasi Password <span class="text-danger">*</span></label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="KeyIcon" />
                  </b-input-group-prepend>
                  <b-form-input v-model="confirm_password" id="confirm-password" placeholder="Ulangi Password Baru" type="password" />
                </b-input-group>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
                <small v-if="password_mismatch" class="text-danger" style="font-size:10px">Password tidak cocok!</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <template #modal-footer>
      <b-button variant="outline-danger" size="sm" class="float-right mr-05" @click="cancel">Batal</b-button>
      <b-button variant="outline-warning" size="sm" class="float-right" @click.prevent="submit">Reset Password</b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, VBModal, BCard, BCardBody, BForm, BFormGroup, BInputGroup, BInputGroupPrepend, BFormInput, BButton, BAlert } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "resetPasswordSmdUser",
  components: {
    ValidationProvider, ValidationObserver,
    BModal, BCard, BCardBody, BForm, BFormGroup,
    BInputGroup, BInputGroupPrepend, BFormInput, BButton, BAlert,
    "loader-component": floating_loader,
  },
  props: { data: Object },
  data() {
    return { is_loading: false, new_password: "", confirm_password: "", password_mismatch: false, required };
  },
  methods: {
    submit() {
      this.$refs.formRules.validate().then((success) => {
        if (success) {
          this.password_mismatch = false;
          if (this.new_password !== this.confirm_password) {
            this.password_mismatch = true;
            return;
          }
          this.is_loading = true;
          const api = process.env.VUE_APP_API_URL + "smd-users/reset-password/" + this.data._id;
          useJwt.axiosIns
            .post(api, { data: { new_password: this.new_password, platform: this.data.platform } })
            .then(() => {
              this.resetForm();
              this.$bvModal.hide("modal-reset-password-smd-user");
              this.$toast({ component: ToastificationContent, position: "top-right",
                props: { title: "Berhasil", icon: "CheckCircleIcon", variant: "success", text: "Password berhasil direset" },
              });
            })
            .finally(() => { this.is_loading = false; });
        }
      });
    },
    cancel() {
      this.resetForm();
      this.$bvModal.hide("modal-reset-password-smd-user");
    },
    resetForm() { this.new_password = ""; this.confirm_password = ""; this.password_mismatch = false; },
  },
  directives: { "b-modal": VBModal },
};
</script>
